import React from 'react'
import PropTypes from 'prop-types';
import Sample from '../sample/index'

import FileUpload from '../form/upload/file'
import Cropper from '../image-panel/imageCropper'
import Image from '../image-panel/imagePanel'

import './index.styl'
class ImageSample extends Sample {

    state = {}

    i18n = 'app.components.image.'

    constructor(props) {
        super(props)
        this.getTitle = this.getTitle.bind(this)
        this.getBody = this.getBody.bind(this)
    }

    getTitle() {
        return 'sample.' + this.i18n + 'page.title'
    }

    getBody() {
        return <ImageSubSample i18n={this.i18n} />
    }
}

class ImageSubSample extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.setImage = this.setImage.bind(this)
    }

    setImage(image) {
        this.setState({image: image})
        return new Promise( resolve => setTimeout(() => resolve(image), 1000))
    }

    render() {
        let { i18n } = this.props;
        let { image=false } = this.state
        let { x=50, y=50, height=200, width=500, } = {}

        return <div className="sample sample-imagePanel">
            <FileUpload upload={ image => this.setImage(image.content) } label={i18n + 'upload'} />
            { image && <Image data={image} {...{height, width, x, y}} /> }
            { image && <Cropper source={image} save={console.log} cropping={console.log} cropBoxData={ {height, width, x, y} } /> }
        </div>
    }
}

export default ImageSample
